import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import BalanceSheet from "../../../containers/modules/report/balance-sheet";

export default function BalanceSheetRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="balance-sheet"
      index
      element={
        <AccessControl
          name={"Balance Sheet Show"}
          auth={authUser}
          component={() => <BalanceSheet />}
        />
      }
    ></Route>
  );
}
